
{
  "hero": {
    "title": "寻找香港值得信赖的服务提供者",
    "subtitle": "与经过验证的专业人士联系，满足您的家庭和商业需求",
    "cta": "开始使用",
    "searchPlaceholder": "您在寻找什么服务？"
  },
  "howItWorks": {
    "title": "如何运作",
    "step1": {
      "title": "搜索",
      "description": "浏览我们经过验证的服务提供者目录"
    },
    "step2": {
      "title": "联系",
      "description": "通过WhatsApp直接联系服务提供者"
    },
    "step3": {
      "title": "评价",
      "description": "留下反馈帮助他人做出明智决定"
    }
  },
  "categories": {
    "title": "热门类别",
    "viewAll": "查看所有类别"
  },
  "featured": {
    "title": "精选服务提供者",
    "viewAll": "查看所有服务提供者"
  },
  "cta": {
    "provider": {
      "title": "准备好发展您的业务了吗？",
      "subtitle": "加入已在我们平台上的数千名服务提供者",
      "button": "列出您的服务"
    }
  },
  "providerCta": {
    "title": "准备好发展您的业务了吗？",
    "description": "加入已在我们平台上的数千名服务提供者",
    "listServiceFree": "列出您的服务 - 免费",
    "upgradePremium": "升级至高级版",
    "addNewListing": "添加新列表"
  }
}
